import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import Layout from "./components/Layout";
import SEOHead from "./components/SEOHead";
import { doctorPhysicianSchema } from "./data/seoSchemas";
import Banner from "./components/Banner";
import Health from "./components/Health";
import Knowledge from "./components/Knowledge";
import WhyUs from "./components/WhyUs";
import Services from "./components/Services";
import Reviews from "./components/Reviews";
import Blogs from "./components/Blogs";
import BlogDetail from "./components/BlogDetail";
import BookAppointment from "./components/BookAppointment";
import DoctorProfile from "./components/DoctorProfile";
import GallerySection from "./components/GallerySection";
import Contact from "./components/Contact";
import UsefulLinks from "./components/UsefulLinks";
import PrivacyPolicy from "./components/PrivacyPolicy";

import { AuthProvider } from "./context/AuthContext";
import AdminLogin from "./components/admin/AdminLogin";
import AdminDashboard from "./components/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Dedicated Doctor & Management Portal Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />

            {/* Public Patient Website Routes */}
            <Route path="/" element={<Layout />}>
            {/* Home Page Route */}
            <Route
              index
              element={
                <>
                  <SEOHead
                    title="Dr. Sunil Apsingi | Senior Orthopedic, Arthroscopy & Joint Replacement Surgeon"
                    description="Dr. Sunil Apsingi (MS Ortho PGI Chandigarh) is a renowned Chief Arthroscopy & Robotic Joint Replacement Surgeon in HITEC City, Hyderabad with 23+ years of excellence in knee, shoulder, sports medicine, and robotic surgeries."
                    canonicalPath="/"
                    schemaJson={doctorPhysicianSchema}
                  />
                  <Banner />
                  <Health />
                  <Knowledge />
                  <WhyUs />
                  <Services showAll={false} />
                  <Reviews />
                  <Blogs showAll={false} />
                </>
              }
            />

            {/* Subpages */}
            <Route
              path="aboutus"
              element={
                <>
                  <DoctorProfile />
                  <Knowledge />
                </>
              }
            />
            <Route path="profile" element={<DoctorProfile />} />
            <Route path="services" element={<Services showAll={true} />} />
            <Route path="blogs" element={<Blogs showAll={true} />} />
            <Route path="blogs/:id" element={<BlogDetail />} />
            <Route path="gallery" element={<GallerySection />} />
            <Route path="bookappointment" element={<BookAppointment />} />
            <Route path="contact" element={<Contact />} />
            <Route path="usefullinks" element={<UsefulLinks />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />

            {/* 404 Catch-All Fallback */}
            <Route
              path="*"
              element={
                <div className="container py-5 text-center my-5">
                  <SEOHead
                    title="Page Not Found | Dr. Sunil Apsingi"
                    noindex={true}
                  />
                  <h1 className="display-4 fw-bold text-navy mb-3">404</h1>
                  <h3 className="mb-3">Page Not Found</h3>
                  <p className="text-muted mb-4">The medical page you are looking for does not exist or has been relocated.</p>
                  <a href="/" className="btn-medical-primary">Return to Homepage</a>
                </div>
              }
            />
          </Route>
        </Routes>
      </div>
    </Router>
  </AuthProvider>
);
}

export default App;
